export const testIds = {
	authFormDrawer: 'authFormDrawer',
	authFormPrivacyNotice: 'authFormPrivacyNotice',
	authFormPrivacyNoticeSwitch: 'authFormPrivacyNoticeSwitch',
	authFormSubmitButton: 'authFormSubmitButton',
	avatarAgent: 'avatarAgent',
	avatarBot: 'avatarBot',
	avatarGroup: 'avatarGroup',
	avatarInfo: 'avatarInfo',
	buttonAttachment: 'buttonAttachment',
	buttonCloseChat: 'buttonCloseChat',
	buttonCloseDrawer: 'buttonCloseDrawer',
	buttonCollapseChat: 'buttonCollapseChat',
	buttonEmoji: 'buttonEmoji',
	buttonExpandChat: 'buttonExpandChat',
	buttonMinimizeChat: 'buttonMinimizeChat',
	buttonOptions: 'buttonOptions',
	buttonSend: 'buttonSend',
	chatRatingDrawer: 'chatRatingDrawer',
	chatRatingEmojiButton: 'chatRatingEmoji',
	chatRatingSendButton: 'chatRatingSendButton',
	chatRatingTextarea: 'chatRatingTextarea',
	chatRatingFeedbackButton: 'chatRatingFeedbackButton',
	chatRatingButtonAi: 'chatRatingButtonAi',
	chatRatingButtonAgent: 'chatRatingButtonAgent',
	closeChatConfirmButton: 'closeChatConfirmButton',
	closeChatDeclineButton: 'closeChatDeclineButton',
	closeChatDrawer: 'closeChatDrawer',
	flashMessage: 'flashMessage',
	gdprDrawer: 'gdprDrawer',
	headerTitle: 'headerTitle',
	headerStatus: 'headerStatus',
	headerBadge: 'headerBadge',
	inlineEmojiPicker: 'inlineEmojiPicker',
	messageAttachment: 'messageAttachment',
	messageAgent: 'messageAgent',
	messageBot: 'messageBot',
	messageBotReply: 'messageBotReply',
	messageBotBack: 'messageBotBack',
	messageContact: 'messageContact',
	messageFile: 'messageFile',
	messageGroup: 'messageGroup',
	messageImage: 'messageImage',
	optionsAccessibility: 'optionsAccessibility',
	optionsDrawer: 'optionsDrawer',
	optionsExpandChat: 'optionsExpandChat',
	optionsPrivacyNotice: 'optionsPrivacyNotice',
	optionsSounds: 'optionsSounds',
	optionsTranscript: 'optionsTranscript',
	popup: 'popup',
	popupMessage: 'popupMessage',
	popupButton: 'popupButton',
	popupButtonClose: 'popupButtonClose',
	productCard: 'productCard',
	productCardArrowLeft: 'productCardArrowLeft',
	productCardArrowRight: 'productCardArrowRight',
	productCardButton: 'productCardButton',
	productCardCarousel: 'productCardCarousel',
	productCardDescription: 'productCardDescription',
	productCardImage: 'productCardImage',
	productCardInfo: 'productCardInfo',
	productCardPrice: 'productCardPrice',
	productCardTitle: 'productCardTitle',
	systemMessage: 'systemMessage',
	textarea: 'textarea',
	textareaPreviewFile: 'textareaPreviewFile',
	textareaPreviewImage: 'textareaPreviewImage',
	transcriptInput: 'transcriptInput',
	transcriptSendButton: 'transcriptSend',
	ticketFormDrawer: 'ticketFormDrawer',
	ticketFormSubmitButton: 'ticketFormSubmitButton',
	widgetButton: 'widgetButton',
	widgetButtonFrame: 'widgetButtonFrame',
	widgetButtonText: 'widgetButtontext',
	widgetImagePreview: 'widgetImagePreview',
	widgetMessenger: 'widgetMessenger',
	widgetMessengerFrame: 'widgetMessengerFrame',
	widgetOnlineBadge: 'widgetOnlineBadge',
	widgetPopupFrame: 'widgetPopupFrame',
	widgetTypingFrame: 'widgetTypingFrame',
	widgetUnreadMessagesBadge: 'widgetUnreadMessagesBadge',
	widgetHeader: 'widgetHeader',
}
